import {
    GET_TALLERES_SUCCESS,
    GET_TALLERES_FAIL,
    CREATE_TALLER_SUCCESS,
    CREATE_TALLER_FAIL,
    UPDATE_TALLER_SUCCESS,
    UPDATE_TALLER_FAIL,
    DELETE_TALLER_SUCCESS,
    DELETE_TALLER_FAIL,
} from './types';
import * as workshopsApi from '../../api/workshops';

// List tallers
export const listTalleres = () => async dispatch => {
    try {
        const res = await workshopsApi.listWorkshops();
        dispatch({
            type: GET_TALLERES_SUCCESS,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: GET_TALLERES_FAIL
        });
    }
};

// Create taller
export const createTaller = (nombre, descripcion, fechaInicio) => async dispatch => {
    try {
        const res = await workshopsApi.createWorkshop({ nombre, descripcion, fechaInicio });
        dispatch({
            type: CREATE_TALLER_SUCCESS,
            payload: res.data
        });
        return { success: true };
    } catch (err) {
        const detail = err.response?.data?.detail || 'Error al crear el taller.';
        dispatch({ type: CREATE_TALLER_FAIL, payload: detail });
        return { success: false, detail };
    }
};
// Update taller
export const updateTaller = (id, nombre, descripcion, fechaInicio) => async dispatch => {
    try {
        const res = await workshopsApi.updateWorkshop({ id, nombre, descripcion, fechaInicio });
        dispatch({
            type: UPDATE_TALLER_SUCCESS,
            payload: res.data
        });
        return { success: true };
    } catch (err) {
        const detail = err.response?.data?.detail || 'Error al actualizar el taller.';
        dispatch({ type: UPDATE_TALLER_FAIL, payload: detail });
        return { success: false, detail };
    }
};

// Delete taller
export const deleteTaller = id => async dispatch => {
    try {
        const res = await workshopsApi.deleteWorkshop(id);
        dispatch({
            type: DELETE_TALLER_SUCCESS,
            payload: res.data
        });
        return { success: true };
    } catch (err) {
        const detail = err.response?.data?.detail || 'Error al eliminar el taller.';
        dispatch({ type: DELETE_TALLER_FAIL, payload: detail });
        return { success: false, detail };
    }
};
